import React, { useState } from "react";

const CopyButton = ({ code }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <button
      onClick={handleCopy}
      className={`text-sm transition-colors underline ${
        copied 
          ? 'text-green-600 hover:text-green-800' 
          : 'text-blue-600 hover:text-blue-800'
      }`}
    >
      {copied ? '✅ Code copied!' : '📋 Copy code to clipboard'}
    </button>
  );
};

export default CopyButton;
